import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getAccessRulesAPI } from './api';

export const GET_ACCESS_RULES = 'getAccessRules';

export function useGetAccessRules() {
  const tenantId = getTenantIDBasedOnURL();

  const { data, isLoading, isFetching, isError, refetch } = useQuery(
    [GET_ACCESS_RULES, tenantId],
    () => getAccessRulesAPI(),
  );

  return {
    accessRules: (data && data.accessRules) || [],
    refetchAccessRules: refetch,
    isLoading,
    isFetching,
    isError,
  };
}

